import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import {
  LANG_LABELS,
  SUPPORTED_LANGS,
  isSupportedLang,
  setStoredLang,
  type EfsLang,
} from '@/lib/i18n';

export const LangSwitcher = () => {
  const { i18n, t } = useTranslation();
  const current: EfsLang = isSupportedLang(i18n.language) ? i18n.language : 'ja';

  const change = (lang: EfsLang) => {
    void i18n.changeLanguage(lang);
    setStoredLang(lang);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          aria-label={t('efs.common.topnav.lang')}
          title={t('efs.common.topnav.lang')}
          className="gap-1 px-2"
        >
          <Languages className="h-4 w-4" />
          <span className="text-xs">{LANG_LABELS[current]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        {SUPPORTED_LANGS.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onSelect={() => change(lang)}
            className={lang === current ? 'font-semibold' : undefined}
          >
            {LANG_LABELS[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
